/* eslint-disable import/no-named-as-default-member */
import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { FREE_COURSE_LANGUAGES, languages } from 'consts/languages';

const supportedLngs = [...Object.keys(languages), ...FREE_COURSE_LANGUAGES];

i18next
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: process.env.REACT_APP_LOCALE,

        fallbackLng: 'en',

        defaultNS: 'translation',

        load: 'languageOnly',

        supportedLngs: supportedLngs,

        debug: false,

        interpolation: {
            escapeValue: false,
        },

        backend: {
            requestOptions: {
                cache: 'no-store',
            },
        },

        detection: {
            order: ['querystring', 'path'],
            caches: [],
        },
    });

export default i18next;
